import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";

export const GroupCard = ({data}) => {
  const {name, total_user_count} = data;
  return (
    <CardBody>
      <CardTitle tag="h3">
        <CardText>Name : {name} </CardText>
      </CardTitle>
      <CardText style={{display: "flex", alignItems: "baseline"}}>
        Total Users : {total_user_count}
      </CardText>
    </CardBody>
  );
};
